import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Dictionary } from 'lodash';
import { NotificationAction, NotificationMessage } from 'src/app/shared/dialogs/notifications/notifications.service';

const ICONS: Dictionary<string> = {
  error: 'components--radio-close-off-md',
  warn: 'general--warning-current-color',
};

const DEFAULT_ICON = 'general--check-md';

@Component({
  selector: 'craft-notification-item',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
  standalone: false,
})
export class NotificationItemComponent implements OnInit {
  @Input() public item: NotificationMessage;
  @Output() public close = new EventEmitter<void>();
  @Output() public action = new EventEmitter<NotificationAction>();

  public iconName: string;

  constructor() {}

  public ngOnInit(): void {
    this.iconName = (typeof this.item.classNames === 'string' ? ICONS[this.item.classNames] : void 0) || DEFAULT_ICON;
  }
}
